<main>
  <!-- ── S1: Hero editorial ── -->
  <section class="about-section about-section--alt about-hero">
    <div class="prose-container">
      <h1 class="about-hero__title">{{ data.hero.title }}</h1>
      <p class="about-hero__subtitle">{{ data.hero.subtitle }}</p>
    </div>
  </section>

  <!-- ── S2: Origen / Historia ── -->
  <section class="about-section">
    <div class="prose-container" aos="fade-up">
      <h2 class="about-section__title">{{ data.origin.title }}</h2>
      <div class="about-prose">
        @for (paragraph of data.origin.paragraphs; track $index) {
          <p>{{ paragraph }}</p>
        }
      </div>
      <blockquote class="about-blockquote">
        <p class="about-blockquote__text">{{ data.origin.quote.text }}</p>
        <cite class="about-blockquote__author">— {{ data.origin.quote.author }}</cite>
      </blockquote>
    </div>
  </section>

  <!-- ── S3: Filosofía / Valores ── -->
  <section class="about-section about-section--alt">
    <div class="about-grid" aos="fade-up">
      <h2 class="about-section__title about-section__title--centered">Nuestra filosofía</h2>
      <div class="about-values__grid">
        @for (value of data.values; track value.title) {
          <div class="about-values__item">
            <div class="about-values__icon">
              <app-icon [icon]="valueIcons[value.icon]" [size]="40" />
            </div>
            <h3 class="about-values__title">{{ value.title }}</h3>
            <p class="about-values__desc">{{ value.description }}</p>
          </div>
        }
      </div>
    </div>
  </section>

  <!-- ── S4: Mascota ── -->
  <section class="about-section about-section--bleed-left">
    <div class="about-mascot__layout" aos="fade-up">
      <img
        src="images/logo/storytelling_con_fondo.jpg"
        alt="El alma de Perrón Store"
        class="about-mascot__image"
      />
      <div class="about-mascot__content">
        <h2 class="about-section__title">{{ data.mascot.title }}</h2>
        <div class="about-prose">
          @for (paragraph of data.mascot.paragraphs; track $index) {
            <p>{{ paragraph }}</p>
          }
        </div>
      </div>
    </div>
  </section>

  <!-- ── S5: Tienda física ── -->
  <section class="about-section about-section--bleed-right">
    <div class="about-store__layout" aos="fade-up">
      <div class="about-store__content">
        <h2 class="about-section__title">{{ data.store.title }}</h2>
        <div class="about-prose">
          @for (paragraph of data.store.paragraphs; track $index) {
            <p>{{ paragraph }}</p>
          }
        </div>
        <div class="about-store__details">
          <div class="about-store__info-item">
            <app-icon [icon]="mapPinIcon" [size]="20" class="about-store__info-icon" />
            <span>{{ data.store.address }}</span>
          </div>
          <div class="about-store__info-item">
            <app-icon [icon]="clockIcon" [size]="20" class="about-store__info-icon" />
            <span>{{ data.store.schedule }}</span>
          </div>
          <div class="about-store__nav-links">
            <a
              [href]="data.store.mapUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="about-store__nav-link"
              aria-label="Abrir en Google Maps"
            >
              <img src="images/logo/g_maps_logo.png" alt="Google Maps" width="32" height="32" />
            </a>
            <a
              href="https://ul.waze.com/ul?venue_id=180813923.1808466912.25261033"
              target="_blank"
              rel="noopener noreferrer"
              class="about-store__nav-link"
              aria-label="Abrir en Waze"
            >
              <img src="images/logo/waze_logo.png" alt="Waze" width="32" height="32" />
            </a>
          </div>
        </div>
      </div>
      <iframe
        [src]="mapEmbedUrl"
        class="about-store__map"
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        title="Ubicación de Perrón Store en Google Maps"
      ></iframe>
    </div>
  </section>

  <!-- ── S6: Comunidad en números ── -->
  <section class="about-section about-section--alt">
    <div class="about-grid" aos="fade-up">
      <h2 class="about-section__title about-section__title--centered">Comunidad en números</h2>
      <div class="about-stats__grid">
        @for (stat of data.stats; track stat.label) {
          <div class="about-stats__item">
            <div class="about-stats__value" [countUp]="stat.value"></div>
            <div class="about-stats__label">{{ stat.label }}</div>
          </div>
        }
      </div>
    </div>
  </section>

  <!-- ── S7: CTA de cierre ── -->
  <app-comunidad-block [data]="communityData()" [loading]="communityLoading()" />
</main>
